module.exports = __webpack_public_path__ + "static/media/cont611.bb8b191.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont611.mp4
// module id = dGeO
// module chunks = 0